// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
/**
 * 图形元素 实体类
 * 定义所有图形元素的基类
 */
export abstract class ShapeElement extends BaseEntity {
  /** DesignId : 设计期ID */
  private _designId: string;

  /** 设置：DesignId */
  public get designId() {
    return this._designId;
  }

  /** 获取：DesignId */
  public set designId(value: string) {
    this._designId = value;
  }

  constructor() {
    super();
    this._designId = '';
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ShapeElement, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.designId = element.designId;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.designId = json.DesignId;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.DesignId = this.designId;
  }
}
